import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/faqs";
import Reveal from "@/components/base/Reveal";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <span className="flex items-center gap-2 text-xs tracking-[0.3em] text-primary-500">
              <i className="ri-question-line" />
              FAQ
            </span>
            <h2 className="heading-serif mt-3 text-2xl font-black text-foreground-950 md:text-3xl">
              关于深夜吃瓜，你想知道的大概都在这
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-500">
              还有别的问题？直接给我们写邮件，我们通常会在两个工作日内回复。
            </p>
            <a
              href="mailto:hello@shenyechigua.com"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:border-accent-500 hover:text-accent-500"
            >
              <i className="ri-mail-send-line" />
              联系我们
            </a>
          </Reveal>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <Reveal key={faq.q} delay={index * 40}>
                    <div
                      className={`overflow-hidden rounded-lg border transition-colors ${
                        isOpen
                          ? "border-primary-500/50 bg-background-100"
                          : "border-background-200/80 bg-background-100/60"
                      }`}
                    >
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        aria-expanded={isOpen}
                        className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                      >
                        <h3 className="heading-serif text-sm font-bold text-foreground-950 md:text-base">
                          {faq.q}
                        </h3>
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                            isOpen ? "bg-primary-500 text-background-50 dark:text-foreground-950" : "bg-background-200 text-foreground-600"
                          }`}
                        >
                          <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-base`} />
                        </span>
                      </button>
                      {isOpen && (
                        <p className="border-t border-background-200/70 px-5 py-4 text-sm leading-relaxed text-foreground-500">
                          {faq.a}
                        </p>
                      )}
                    </div>
                  </Reveal>
                );
              })}
            </div>

            <Reveal delay={120}>
              <div className="mt-8 flex flex-col gap-4 rounded-lg border border-secondary-200/50 bg-secondary-50/50 p-5 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <h3 className="heading-serif text-base font-bold text-foreground-950">
                    准备好加入今晚的讨论了？
                  </h3>
                  <p className="mt-1.5 text-sm text-foreground-500">
                    挑一个感兴趣的话题，看看别人都在聊什么。
                  </p>
                </div>
                <Link
                  to="/topics"
                  className="inline-flex shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600 dark:text-foreground-950"
                >
                  <i className="ri-chat-new-line" />
                  开始吃瓜
                </Link>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}